/**
 * Reading progress bar for single articles.
 *
 * Writes a 0–1 `--progress` custom property; CSS owns the visual. Measured
 * against the article element rather than the whole document so the footer,
 * related row and CTA don't count as "still reading".
 */
export function initReadingProgress(): void {
  const bar = document.querySelector<HTMLElement>('[data-reading-progress]');
  const article = document.querySelector<HTMLElement>('[data-reading-target]');
  if (!bar || !article) return;

  let queued = false;

  const update = (): void => {
    queued = false;
    const start = article.offsetTop;
    // The article counts as finished once its end reaches the lower third of
    // the viewport — otherwise the bar can never fill on a short piece.
    const span = article.offsetHeight - window.innerHeight * 0.35;
    const progress = span > 0 ? (window.scrollY - start) / span : 1;
    bar.style.setProperty('--progress', Math.min(1, Math.max(0, progress)).toFixed(4));
  };

  const schedule = (): void => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  update();
}
